import './styles.scss';

const RelatedDocumentsSelected = ({ children }) => {
  return (
    <div className="relatedDocuments__selected">
      <label className="selected__label">Normas e Desenhos Padrão Selecionados</label>
      <div className="selected__items">{children}</div>
    </div>
  );
};

export default RelatedDocumentsSelected;
